export enum VEND_FEATURE_SETTINGS {
    SyncManufacturerSku = "syncManufacturerSku", 
    // Add more feature toggles here as needed
}

export enum WIX_FEATURE_SETTINGS {
    CreateFormOnSubmission = "createFormOnSubmission", 
}


// WEBPACK FOOTER //
// ./src/state/integration/IntegrationFeatureSettings.ts